import z from "zod";

export const GeneratePurchaseOrderFormSchema = z.object({
    type: z.string(),
    reference_number: z.string().min(2, "Reference number is required"),
    supplier_id: z.string().min(1, "Supplier is required"),
    order_date: z.string().min(1, "Issued date is required."),
    project: z.string().min(1, "Project is required"),
    items: z
        .array(
            z.object({
                serial_number: z.number(),
                description: z.string().min(1, "description is required"),
                quantity: z.number().gte(1, "Quantity must be greater than 0"),
                unit: z.string().min(1, "Unit is required"),
                unit_price: z.number().gte(0),
                tax_rate: z.number().gte(0).lte(100),
            }),
        )
        .min(1, "Items is required"),
    recipient: z.string().min(2, "Reciepent is required"),
    recipient_designation: z
        .string()
        .min(1, "Reciepent Designation is required")
        .default("sir/ma'am"),
    subject: z.string().min(2, "Subject is required"),
    terms_and_conditions: z.array(
        z.object({
            value: z.string().min(3, "Terms and conditions is required"),
        }),
    ),
    remarks: z.string().optional(),
});

export const CreateGeneratePurchaseOrderSchema =
    GeneratePurchaseOrderFormSchema.omit({
        terms_and_conditions: true,
    }).extend({
        terms_and_conditions: z.array(z.string()),
    });

export const UpdateGeneratePurchaseOrderSchema =
    CreateGeneratePurchaseOrderSchema;

export type GeneratePurchaseOrderFormSchema = z.infer<
    typeof GeneratePurchaseOrderFormSchema
>;

export type CreateGeneratePurchaseOrderSchema = z.infer<
    typeof CreateGeneratePurchaseOrderSchema
>;

export type UpdateGeneratePurchaseOrderSchema = z.infer<
    typeof UpdateGeneratePurchaseOrderSchema
>;
